import * as countryCoder from './country-coder';
globalThis.countryCoder = countryCoder;
